<template>

  <div class="generic-container">
      <h1>Login test</h1>
      <button @click="login">login</button>
      <button @click="account">account</button>
      <button class="danger" @click="logout">logout</button>
  </div>

</template>

<script setup>
import router from '@/router';
import { useAuth0 } from '@auth0/auth0-vue';
const { user, isAuthenticated, logout, loginWithRedirect  } = useAuth0();

function login() {
  loginWithRedirect();
}

function account() {
  router.push('/account')
}

function logoutWithParams() {
  logout({ logoutParams: { returnTo: 'http://localhost:8080'}})
}
</script>

